module.exports = __webpack_public_path__ + "static/media/li.071b1d57.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/li.svg
// module id = 174
// module chunks = 0